import Swiper, { Navigation} from 'swiper';

const BlogCarousel = () => {
  /* !----------------- SWIPER ------------------! */
  const containers = document.querySelectorAll('.swiper-blog-carousel');

  if (!containers.length) return;

  Swiper.use([Navigation]);

  containers.forEach(container => {
    const swiper = container.querySelector('.swiper');
    const nextEl = container.querySelector('.swiper-button-next');
    const prevEl = container.querySelector('.swiper-button-prev');

    new Swiper(swiper, {
      loop: false,
      spaceBetween: 16,
      slidesPerView: 1,
      navigation: {
        nextEl,
        prevEl,
      },
    });
  });
};

export default BlogCarousel;